<ng-container *ngIf="!datosRecibidos && errorMessage === ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <span class="wait-message">Cargando datos...</span>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage !== ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <div class="wait-message">{{ errorMessage }}</div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage === '' && datosRecibidos">
    <div class="table-header">
        <div class="header-content">
            <span>LISTADO DE TANQUES</span>
            <button mat-icon-button [matMenuTriggerFor]="menu" class="more-vert-btn">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="descargarExcel()">
                <mat-icon>download</mat-icon>
                <span>Exportar a Excel</span>
            </button>
        </mat-menu>
    </div>

    <div class="mat-elevation-z8">
        <div class="top-container">
            <mat-form-field>
                <mat-label>Filtrar</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex.nombre" #input>
            </mat-form-field>
        </div>

        <!--PARA ORDENAR POR UN ELEMENTO-->
        <!--matSortActive="id" matSortDirection="asc"-->
        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="nombreTanque">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID tanque </th>
                <td mat-cell *matCellDef="let element" class="cell" class="dev-reference"> {{element.nombreTanque}} </td>
            </ng-container>

            <ng-container matColumnDef="dispositivoReference">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Dispositivo </th>
                <td mat-cell *matCellDef="let element"  class="router-cell" routerLink="/dispositivo/ver/{{element.dev_id}}"> {{element.dispositivoReference}} </td>
            </ng-container>

            <ng-container matColumnDef="establecimiento">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Establecimiento </th>
                <td mat-cell *matCellDef="let element" class="router-cell" routerLink="/establecimiento/{{element.est_id}}"> {{element.establecimiento}} </td>
            </ng-container>

            <ng-container matColumnDef="espacio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Pos. en Dis. </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.espacio}} </td>
            </ng-container>

            <ng-container matColumnDef="numero">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nº tanque </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.numero}} </td>
            </ng-container>

            <ng-container matColumnDef="cerveza">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Cerveza </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.cerveza}} </td>
            </ng-container>

            <ng-container matColumnDef="capacidad">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Capacidad (L) </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.capacidad}} </td>
            </ng-container>

            <ng-container matColumnDef="cliente" *ngIf="userDataInfo.pro_id == 4">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.cliente}} </td>
            </ng-container>

            <ng-container matColumnDef="operaciones">
                <th mat-header-cell *matHeaderCellDef> Operaciones </th>
                <td mat-cell *matCellDef="let element">
                  <div class="button-container">
                    <button mat-mini-fab class="ver-btn" matTooltip="Ver tanque" aria-label="Ver tanque" routerLink="/tanque/{{element.id}}">
                        <mat-icon>remove_red_eye</mat-icon>
                      </button>
                    <button *ngIf="userDataInfo.pro_id == 4 || userDataInfo.pro_id == 1" mat-mini-fab class="edit-btn" matTooltip="Editar tanque" 
                     aria-label="Editar tanque" routerLink="{{element.id}}/editar">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator 
            [pageSizeOptions]="[25,50,100]" 
            showFirstLastButtons 
            aria-label="Elige una página"
            class="customPaginator">
        </mat-paginator>
    </div>
</ng-container>

